// extracted by mini-css-extract-plugin
export default {"buttonContainer":"customer-redirect-url-container__button-container__S_j6o"};